// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1fnRM","upload":"Small_upload__2tqlI","imageWrap":"Small_imageWrap__j8Kg1","removeBtn":"Small_removeBtn__2VPr8"};